"use strict";
import BtnBase from './btnbase';
import Youtube from '../parts/youtube';

class BtnMovie extends BtnBase{
	constructor($con){
		super($con);
	}
	
	init(){
	}
	
	responsiveHandler(){
		super.responsiveHandler();
	}
	
	over(){
		super.over();
		this.$con.find('.img').velocity('stop').velocity({scaleX:1.03,scaleY:1.03},{duration:800,easing:'easeOutExpo'});
		this.$con.find('.BtnPlay').addClass('over');
	}
	
	out(){
		super.out();
		this.$con.find('.img').velocity('stop').velocity({scaleX:1,scaleY:1},{duration:150});
		this.$con.find('.BtnPlay').removeClass('over');
	}
	
	click(){
		super.click();
		Youtube.open( this.$con.data('youtubeid') );
	}

}

export default BtnMovie;


// WEBPACK FOOTER //
// ./js/btn/btnmovie.js